import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import CreatePost from "./pages/admin/CreatePost";
import EditPost from "./pages/admin/EditPost";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminShortcut from "./components/AdminShortcut";

import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Loader from "./components/Loader";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import Insights from "./pages/Insights";
import SingleInsight from "./pages/SingleInsight";
import Posts from "./pages/admin/Posts";

// SERVICE DETAIL PAGES (you will create these later)
import Banking from "./pages/services/Banking";
import Litigation from "./pages/services/Litigation";
import Conveyancing from "./pages/services/Conveyancing";
import Criminal from "./pages/services/Criminal";
import Commercial from "./pages/services/Commercial";
import Intellectual from "./pages/services/Intellectual";
import Probate from "./pages/services/Probate";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
       <AdminShortcut />
      <Navbar />

      <Routes>
        {/* MAIN PAGES */}
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<SingleInsight />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/admin/login" element={<AdminLogin />} />
       
       
        <Route
  path="/admin/dashboard"
  element={
    <ProtectedRoute>
      <Dashboard />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/create-post"
  element={
    <ProtectedRoute>
      <CreatePost />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/posts"
  element={
    <ProtectedRoute>
      <Posts />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/edit-post/:id"
  element={
    <ProtectedRoute>
      <EditPost />
    </ProtectedRoute>
  }
/>

        {/* SERVICE DETAIL PAGES */}
        <Route path="/services/banking" element={<Banking />} />
        <Route path="/services/litigation" element={<Litigation />} />
        <Route path="/services/conveyancing" element={<Conveyancing />} />
        <Route path="/services/criminal" element={<Criminal />} />
        <Route path="/services/commercial" element={<Commercial />} />
        <Route path="/services/intellectual" element={<Intellectual />} />
        <Route path="/services/probate" element={<Probate />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;